import { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const categoriesCollection = collection(db, 'categories');
        const snapshot = await getDocs(categoriesCollection);

        const categoriesData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setCategories(categoriesData);
        setError(null);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError('Failed to fetch categories');
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const getCategoryById = (categoryId) => {
    return categories.find(category => category.id === categoryId);
  };

  const getCategoriesByIds = (categoryIds) => {
    if (!Array.isArray(categoryIds)) return [];
    return categories.filter(category => categoryIds.includes(category.id));
  };

  const getCategoryNamesByIds = (categoryIds) => {
    if (!Array.isArray(categoryIds)) return [];
    return categories
      .filter(category => categoryIds.includes(category.id))
      .map(category => category.name);
  };

  return {
    categories,
    loading,
    error,
    getCategoryById,
    getCategoriesByIds,
    getCategoryNamesByIds
  };
};

export default useCategories;
